export default __webpack_public_path__ + "static/media/Axehitting-1.cbfd4b92.png";